module.exports = __webpack_public_path__ + "static/media/bms11.1413e109.jpg";